import React from "react";

function JudgingParameters({ parameters }) {
  return (
    <div className="flex flex-col gap-4 my-4 ">
      <h1 className="text-xl font-gilroy-semibold">
        {parameters?.title}
      </h1>

      {parameters?.response?.length > 0 && (
        <ul className=" flex flex-col gap-2 text-[#707C97] ">
          {parameters.response.map((item, index) => (
            <li key={item.substr(0, 6)}>{`${index + 1}. ${item}`}</li>
          ))}
        </ul>
      )}
    </div>
  );
}

export default JudgingParameters;
